import { Disclosure, Transition } from "@headlessui/react";
import { VacancyCard } from "../../features/school/VacancyCard";
import ColumnLayout from "../ColumnLayout";
import { Fragment } from "react";
import VacancyListDisclosureDetail from "./VacancyListDisclosureDetail";
import { useVacanciesState } from "../../states/vacancy-state/vacancy.state";
import { Vacancy } from "../../models/vacancy/vacancy";
import usePermissions from "../../hooks/usePermissions";
import { PERMISSIONS } from "../../auth/permissions";
import useAuthData from "../../auth/useAuthData";
import { useQueryParams } from "../../hooks/useQueryParams";
import { NidessoQueryParams } from "../router/query-params";
import {
  add,
  getList,
  remove,
} from "../../helpers/update-list-query-param-operators";
import { Equals } from "../../helpers/helper-functions";

type VacancyListProps = {
  vacancyButtonTemplate?: (v: Vacancy) => JSX.Element;
};

function VacancyList({
  vacancyButtonTemplate = (v) => <VacancyCard vacancy={v} onClick={() => {}} />,
}: VacancyListProps) {
  const { vacancies } = useVacanciesState();
  const { hasPermissions } = usePermissions();
  const { currentTeacher } = useAuthData();
  const { queryParams, updateListQueryParam } = useQueryParams();

  const onClickDisclosure = (id: string, open: boolean) => {
    updateListQueryParam(
      NidessoQueryParams.OpenVacancies,
      open ? remove(id) : add(id),
    );
  };

  return (
    <>
      <ColumnLayout
        layouts={[
          { columns: 1, threshold: 0 },
          { columns: 2, threshold: 1280 },
        ]}
        items={vacancies.map((v) => (
          <Disclosure
            key={v.id}
            defaultOpen={getList(
              NidessoQueryParams.OpenVacancies,
              queryParams,
            ).some(Equals(v.id))}
          >
            {({ open }) => (
              <>
                <Disclosure.Button
                  onClick={() => onClickDisclosure(v.id, open)}
                >
                  {vacancyButtonTemplate(v)}
                </Disclosure.Button>
                {/* Todo: Check flickering with transition */}
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Disclosure.Panel className="block rounded-lg bg-white p-4">
                    <VacancyListDisclosureDetail
                      vacancy={v}
                      preselectedSubstituteTeacher={
                        !hasPermissions([
                          PERMISSIONS.CanUpdateNotOwnedVacancy,
                        ]) && v.absentTeacher.id !== currentTeacher?.id
                          ? currentTeacher
                          : undefined
                      }
                    />
                  </Disclosure.Panel>
                </Transition>
              </>
            )}
          </Disclosure>
        ))}
      />
    </>
  );
}

export default VacancyList;
